export default __webpack_public_path__ + "static/dev-prev-miami-db02171882add19c64d72abc72b956af.jpg";